import React from 'react';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import { Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import svgImage from './assets/error.svg';
import messages from './messages.tsx';

const ICON_SIZE = 200;

const ProjectOverLimitErrorPage = ({
	isEmbedded,
	planUrl,
}: {
	isEmbedded?: boolean;
	planUrl?: string;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Flex
			alignItems="center"
			justifyContent="center"
			xcss={isEmbedded ? embedStyles : containerStyles}
		>
			<EmptyState
				imageUrl={svgImage}
				header={formatMessage(messages.header)}
				description={formatMessage(messages.errorDescription)}
				maxImageHeight={ICON_SIZE}
				maxImageWidth={ICON_SIZE}
				secondaryAction={
					planUrl && (
						<Button href={planUrl} target="_blank">
							{formatMessage(messages.openPlanInJira)}
						</Button>
					)
				}
			/>
		</Flex>
	);
};

export default ProjectOverLimitErrorPage;

const embedStyles = xcss({ height: '100vh' });

const containerStyles = xcss({ height: '100%' });
